type ChatClosedFields = {
  closed_at?: string | null;
  status?: string | null;
};

type ChatClosedWsMessage = {
  type?: string;
  code?: string;
  error_code?: string;
  error?: string;
  message?: string;
  text?: string;
  closed_at?: string;
  closedAt?: string;
};

/** True when a channel/chat is closed (API fields or derived status). */
export function isChannelClosed(
  channel: ChatClosedFields | null | undefined,
): boolean {
  return !!channel?.closed_at || channel?.status === "closed";
}

/** Detect backend WebSocket payloads for closed chats (event or send error). */
export function isChatClosedWsMessage(
  message: ChatClosedWsMessage | null | undefined,
): boolean {
  if (!message) return false;
  if (message.type === "chat_closed") return true;
  if (message.type === "error") {
    const code = message.code ?? message.error_code ?? message.error;
    if (code === "chat_closed") return true;
    const text = String(message.message ?? message.text ?? "").toLowerCase();
    if (text.includes("chat_closed") || text.includes("chat is closed")) {
      return true;
    }
  }
  return false;
}

export function closedAtFromWsMessage(
  message: ChatClosedWsMessage,
): string | undefined {
  const raw = message.closed_at ?? message.closedAt;
  return typeof raw === "string" && raw.trim() ? raw : undefined;
}
